import Modal from "../shared/Modal";
import "./ModalEmbeddingInProgress.css";

type ModalEmbeddingInProgressProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalEmbeddingInProgress = ({
  isOpen,
  onClose,
  onContinue,
}: ModalEmbeddingInProgressProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={true}
        allowClickout={true}>
        <div id="modal-collection-embedding-in-progress">
          <div className="modal-collection-embedding-in-progress-title">
            Embedding in Progress
          </div>

          <div className="modal-collection-embedding-in-progress-content">
            This may take a while but you can check the status by going to the
            Manage Resources page.
          </div>

          <div className="modal-collection-embedding-in-progress-footer">
            <div className="modal-collection-embedding-in-progress-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Close
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Check Status
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalEmbeddingInProgress;
